<template>
	<div>
		<div class="title">被保险人信息</div>
		<div class="mt15 mb16">
			<RadioGroup v-model="hasInsuredPerson" @on-change="onInsuredPersonChange">
				<Radio label="none">无被保险人</Radio>
				<Radio label="has">有被保险人</Radio>
			</RadioGroup>
			
			<!-- 被保险人说明信息 -->
			<div class="insured-desc mt10">
				<div v-if="hasInsuredPerson === 'none'" class="desc-text">
					被保险人: 恒晟源集团及其关联子公司和实际用工单位均作为共同被保险人,详见人员清单对应的被保险人
				</div>
				<div v-else class="desc-text">
					被保险人: 实际用工单位及委托投保人参保的派遣单位均作为共同被保险人,详见人员清单对应的被保险人
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		info: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			hasInsuredPerson: 'none', // 'none' | 'has'
		}
	},
	watch: {
		info: {
			handler(newVal) {
				if (newVal && newVal.insuredList && newVal.insuredList.length > 0) {
					this.hasInsuredPerson = 'has'
				} else {
					this.hasInsuredPerson = 'none'
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		// 被保险人选择变化
		onInsuredPersonChange(value) {
			this.onFormChange()
		},

		// 表单变化通知父组件
		onFormChange() {
			this.$emit('on-change', this.getFormData())
		},

		// 获取表单数据
		getFormData() {
			if (this.hasInsuredPerson === 'none') {
				// 无被保险人时，不传递任何数据
				return {}
			}
			
			// 有被保险人时，传递特定的subjectName信息
			return {
				insuredList: [{
					subjectName: '实际用工单位及委托投保人参保的派遣单位均作为共同被保险人,详见人员清单对应的被保险人'
				}]
			}
		},

		// 表单验证
		async val() {
			return this.getFormData()
		},

		// 草稿箱
		drafts() {
			return new Promise((resolve) => {
				resolve(this.getFormData())
			})
		}
	}
}
</script>

<style scoped lang="less">
.insured-desc {
	background-color: #fff7e6;
	border: 1px solid #ffd591;
	border-radius: 4px;
	padding: 12px 16px;
	margin-top: 10px;
}

.desc-text {
	color: #d46b08;
	font-size: 14px;
	line-height: 1.5;
}


.title {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 15px;
}

.mt15 {
	margin-top: 15px;
}

.mb16 {
	margin-bottom: 16px;
}

.mt10 {
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/InsuredPerson.vue